export const SERVER_LIMITATION = {
  CD_ROMS: 2,
  HDDS: 8,
  NICS: 6,
  IS_ACCUMULATIVE: false,
  ACCUMULATIVE_NUMS: 24,
};
